module.exports = __webpack_public_path__ + "img/9788963010847.f0f51b23.jpg";